import * as Sentry from "@sentry/react";
import { useEffect } from "react";

// Context
import { useAuth } from '@wearetla/tla-essentials-tools/utilities/auth';
import { useApplication } from '/utilities/application';
import { useBreakpoints } from '@wearetla/tla-essentials-tools/utilities/breakpoints';
import { useNavigator } from '@wearetla/tla-essentials-tools/utilities/navigator';

export const SentryDataController = () => {
  const { userData } = useAuth();
  const { isApplication } = useApplication();
  const { activeRoute } = useNavigator();
  const { mobile } = useBreakpoints();

  useEffect(() => {
    Sentry.setTag('isApplication', isApplication)
  }, [isApplication]);

  useEffect(() => {
    Sentry.setTag('isMobile', mobile)
  }, [mobile]);

  useEffect(() => {
    Sentry.setTag('activeRoute', activeRoute?.key);

    if(activeRoute?.key === 'checkout') {
      Sentry.setTag('saleId', activeRoute?.key === 'checkout' ? (window.localStorage?.getItem('checkout-sale-id') ?? null) : null);
    }
  }, [activeRoute])

  useEffect(() => {
    if(userData) {
      Sentry.setUser({
        id: userData.id,
      })
    }
    else {
      Sentry.setUser(null)
    }
  }, [userData])

  return null;
}

export default SentryDataController